import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_10 = { class: "form-label fw-bold" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "form-text mt-n5" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-label fw-bold" }
const _hoisted_20 = { class: "form-text mt-n5" }
const _hoisted_21 = { class: "card-footer d-flex justify-content-end gap-2 py-6 px-9" }
const _hoisted_22 = {
  type: "submit",
  ref: "saveButton",
  class: "btn btn-primary"
}
const _hoisted_23 = { class: "indicator-label" }
const _hoisted_24 = { class: "indicator-progress" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("user.permission")), 1)
      ])
    ]),
    _createVNode(_component_el_form, {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("user.role")), 1),
              _createVNode(_component_el_form_item, { prop: "roles" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.roles,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.roles) = $event)),
                    clearable: "",
                    multiple: "",
                    "collapse-tags-tooltip": "",
                    placeholder: "Please Select",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            (_ctx.isShowUserType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t("user.userType")), 1),
                  _createVNode(_component_el_form_item, { prop: "user_type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.user_type,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.user_type) = $event)),
                        clearable: "",
                        placeholder: "Please Select",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.userTypeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("user.operatingEntity")), 1),
              _createVNode(_component_el_form_item, { prop: "operating_entity" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.operating_entity,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.operating_entity) = $event)),
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    remote: "",
                    placeholder: _ctx.t('common.enterKeyword'),
                    style: {"width":"100%"},
                    "remote-method": _ctx.remoteMethod,
                    loading: _ctx.selectLoading
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("user.advancedManage")), 1),
              _createVNode(_component_el_form_item, { prop: "advanced_manage" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.formData.advanced_manage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.advanced_manage) = $event)),
                    "active-value": 1,
                    "inactive-value": 0,
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("user.showMergeData")), 1),
              _createVNode(_component_el_form_item, { prop: "show_merge_data" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.formData.show_merge_data,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.show_merge_data) = $event)),
                    "active-value": 1,
                    "inactive-value": 0,
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("user.showMergeDataTip")), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("user.allowUnallocatedData")), 1),
              _createVNode(_component_el_form_item, { prop: "allow_unallocated_data" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.formData.allow_unallocated_data,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.allow_unallocated_data) = $event)),
                    "active-value": 1,
                    "inactive-value": 0,
                    placeholder: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("user.allowUnallocatedDataTip")), 1)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_router_link, {
            to: "/users",
            class: "btn btn-secondary align-self-center",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("common.backToList")), 1)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-white btn-active-light-primary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
          }, _toDisplayString(_ctx.t("common.resetDiscard")), 1),
          _createElementVNode("button", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t("common.saveChanges")), 1),
            _createElementVNode("span", _hoisted_24, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_25
            ])
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}